module.exports = __webpack_public_path__ + "img/selection-poster_en.912c5db.jpg";